import React from 'react';
import { MessageCircle, Send, CheckCircle, Clock, TrendingUp, Users } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';

const ResumoGeral = ({ resumo, loading }) => {
  const { darkMode } = useTheme();

  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className={`p-4 rounded-lg animate-pulse ${darkMode ? 'bg-zinc-800' : 'bg-white'}`}>
            <div className={`h-3 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded w-1/2 mb-3`}></div>
            <div className={`h-6 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded w-3/4`}></div>
          </div>
        ))}
      </div>
    );
  }

  if (!resumo) return null;

  const cards = [
    { title: 'Conversas', value: resumo.totalConversas?.toLocaleString() || '0', icon: MessageCircle, bgColor: darkMode ? 'bg-blue-900/20' : 'bg-blue-50', iconColor: 'text-blue-500' },
    { title: 'Recebidas', value: resumo.totalMensagensRecebidas?.toLocaleString() || '0', icon: MessageCircle, bgColor: darkMode ? 'bg-green-900/20' : 'bg-green-50', iconColor: 'text-green-500' },
    { title: 'Enviadas', value: resumo.totalMensagensEnviadas?.toLocaleString() || '0', icon: Send, bgColor: darkMode ? 'bg-purple-900/20' : 'bg-purple-50', iconColor: 'text-purple-500' },
    { title: 'Taxa Resposta', value: `${resumo.taxaRespostaMedia?.toFixed(1) || '0'}%`, icon: CheckCircle, bgColor: darkMode ? 'bg-emerald-900/20' : 'bg-emerald-50', iconColor: 'text-emerald-500' },
    { title: 'Tempo Médio', value: `${resumo.tempoMedioResposta?.toFixed(0) || '0'} min`, icon: Clock, bgColor: darkMode ? 'bg-orange-900/20' : 'bg-orange-50', iconColor: 'text-orange-500' },
    { title: 'Ativas', value: resumo.conversasAtivas?.toLocaleString() || '0', icon: Users, bgColor: darkMode ? 'bg-pink-900/20' : 'bg-pink-50', iconColor: 'text-pink-500' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div
            key={index}
            className={`p-2 sm:p-4 rounded-lg border transition-all hover:shadow-md ${
              darkMode ? 'bg-zinc-800 border-gray-700' : 'bg-white border-gray-200'
            }`}
          >
            <div className="flex items-center gap-1 mb-1 sm:mb-2">
              <div className={`p-1 rounded-md flex-shrink-0 ${card.bgColor}`}>
                <Icon className={`w-3 h-3 ${card.iconColor}`} />
              </div>
              <p className={`text-[10px] sm:text-xs font-medium truncate ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{card.title}</p>
            </div>
            <p className={`text-sm sm:text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{card.value}</p>
          </div>
        );
      })}
    </div>
  );
};

export default ResumoGeral;
